import { SessionTutorialSpotlight } from '@/features/session-tutorial/SessionTutorialSpotlight';
import type { SessionTutorialHintProps } from '@/features/session-tutorial/sessionTutorial.types';
import { SESSION_TUTORIAL_UI_ATTRIBUTE } from '@/features/session-tutorial/useInertOutside';
import { Popover, PopoverAnchor, PopoverContent, Text } from '@careflux/primitives';
import { useMemo } from 'react';

/** A short, button-less hint beside a lit-up area; it goes away by itself when the tour moves on. */
export const SessionTutorialHint = ({ target, text }: SessionTutorialHintProps) => {
  const anchorRef = useMemo(() => ({ current: target }), [target]);

  return (
    <>
      <SessionTutorialSpotlight target={target} />
      <Popover open>
        <PopoverAnchor virtualRef={anchorRef} />
        <PopoverContent
          {...{ [SESSION_TUTORIAL_UI_ATTRIBUTE]: '' }}
          onOpenAutoFocus={(event) => event.preventDefault()}
          onInteractOutside={(event) => event.preventDefault()}
          hideWhenDetached
        >
          <output>
            <Text size="sm">{text}</Text>
          </output>
        </PopoverContent>
      </Popover>
    </>
  );
};
